import { faChevronRight, faInfoCircle, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';

import './ServicesStatus.scss';
import { Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { statusServicesService } from 'src/services/Onboarding/support.service';

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

interface Service {
  name: string;
  status?: string;
  response?: {
    error?: {
      data?: {
        responseThirdParty?: string;
      };
    };
  };
  title?: string;
  isLoading: boolean;
}

export const ServicesStatus: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [isModalOpenInfo, setIsModalOpenInfo] = React.useState(false)
  const [errorVal, setErrorVal] = React.useState<any>(null)
  const [modalInfoData, setModalInfoData] = React.useState<Service>({ name: '', status: '', response: {}, title: '', isLoading: false })
  const [services, setServices] = React.useState<Service[]>([
    {
      name: "risk",
      isLoading: true
    },
    {
      name: "credit_history",
      isLoading: true
    },
    {
      name: "cross_core",
      isLoading: true
    },
    {
      name: "bank_vision",
      isLoading: true
    }
  ])
  const [copied, setCopied] = React.useState(false)

  const onRefresh = () => {
    onGetServices()
  }

  const onShowModalInfo = (service: Service): void => {
    setModalInfoData(service)
    setIsModalOpenInfo(true)
  }

  const clasificatingErrors = (response: any, el: any): any => {
    const e = response.response?.error?.data.responseThirdParty
    if (/<\/?[a-z][\s\S]*>/i.test(e)) {
      let parser = new DOMParser()
      const servicesStatus = document.querySelector('.ServicesStatus')
      console.log(servicesStatus?.querySelector('#desc-modal'))
      const $descModal = servicesStatus?.querySelector('#desc-modal')
      let _document = parser.parseFromString(e, "text/html")

      let _body = _document.getElementsByTagName("body")[0]

      if ($descModal) {
        $descModal.innerHTML = _body.innerHTML
      }
      return;
    }
    setErrorVal(<code><pre>{JSON.stringify(e, null, 2)}</pre></code>)
  }

  const onGetServices = async () => {
    setIsLoading(true)
    for (const service of services) {
      service.isLoading = true

      statusServicesService(service.name)
        .then((response) => {
          setIsLoading(false)
          setServices((prevServices) => {
            return prevServices.map((prevService) => {
              if (prevService.name === service.name) {
                return {
                  ...prevService,
                  status: response.data.services[0].status,
                  response: response.data.services[0].response,
                  title: response.data.services[0].title,
                  isLoading: false
                }
              }
              return prevService
            })
          })
        })
        .catch((error) => {
          setIsLoading(false)
          console.error(error)
        })
    }
  }

  const onCopy = () => {
    const el = document.createElement('textarea')
    const e = modalInfoData.response?.error?.data?.responseThirdParty
    el.value = JSON.stringify(e)
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    setCopied(true)
    const timer = setTimeout(() => {
      setCopied(false)
      clearTimeout(timer)
    }, 2000)
  }

  useEffect(() => {
    if (isModalOpenInfo) {
      document.getElementById('desc-modal')?.click()
    }
  }, [isModalOpenInfo])

  useEffect(() => {
    onGetServices()
  }, [])

  return (
    <div className="ServicesStatus">
      <header className="pages-header">
        <nav className="pages-nav">
          <ul className="pages">
            <li className="previousPage previousPage-1">
              <Link to="/soporte">Soporte</Link>
            </li>
            <li className="separator">
              <FontAwesomeIcon icon={faChevronRight} />
            </li>
            <li className="currentPage"><strong>Estado De Los Servicios</strong></li>
          </ul>
        </nav>
      </header>
      <ul className="cards">
        {services.map((service) => (
          service.isLoading ? (
            <Skeleton height={120} key={service.name} />
          ) : (
            <li className={`card ${service?.status === 'ERROR' ? 'card--danger' : ''}`} key={service.name}>
              <h3 className="title">{service?.title}</h3>
              <p className="description">Estado: <strong className="status-val">{service?.status === "OK" ? "Activo" : "Inactivo"}</strong></p>
              {service?.status === 'ERROR' && (
                <button className="info-btn" onClick={() => onShowModalInfo(service as Service)}>
                  <FontAwesomeIcon icon={faInfoCircle} />
                </button>
              )}
            </li>
          )
        ))}
      </ul>
      {
        isModalOpenInfo && (
          <>
            <div className="overflow-info" onClick={() => setIsModalOpenInfo(false)}></div>
            <div className="modal-info">
              <div className="modal-info-content">
                <h3 className="title">¿Por qué falla {modalInfoData.title}?</h3>
                <p className="description" id="desc-modal" onClick={() => clasificatingErrors(modalInfoData, this)}><strong className="status-val">{errorVal}</strong></p>
                <div className="buttons">
                  <Button color="secondary" className="close-modal" onClick={() => setIsModalOpenInfo(false)}>Cerrar</Button>
                  <Button color="primary" variant="contained" type="button" onClick={onCopy} disabled={copied}>{copied ? "Error copiado" : "Copiar error"}</Button>
                </div>
              </div>
            </div>
          </>
        )
      }
      <Button
        onClick={onRefresh}
        variant="contained"
        color="primary"
        className="refresh-btn"
        //LOADING

        disabled={isLoading}
      >
        {isLoading ? (
          <Typography variant="button">Actualizando...</Typography>
        ) : (
          <>
            <FontAwesomeIcon icon={faRefresh} />
            <Typography variant="button" style={{ marginLeft: "10px" }}>Actualizar</Typography>
          </>
        )}
      </Button>
    </div>
  )
}
